import Image from "next/image";
import Link from "next/link";
import { getImageUrl } from "@/utils/api-utils";

interface ActivityCardProps {
  activity: {
    id: string;
    slug: string;
    title: string;
    description: string;
    image: string;
    badge: string;
    badgeType: "primary" | "secondary";
    icon: string;
  };
}

export default function ActivityCard({ activity }: ActivityCardProps) {
  const titleClampStyle = {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical" as const,
    overflow: "hidden",
  };

  return (
    <Link
      href={`/doi-song-sinh-vien/${activity.slug}`}
      className="activity-card activity-card--featured"
    >
      <div className="activity-card__image">
        <Image
          src={getImageUrl(activity.image)}
          alt={activity.title}
          width={342}
          height={192}
          loading="lazy"
        />
        <span
          className={`activity-card__badge activity-card__badge--${activity.badgeType}`}
        >
          {activity.badge}
        </span>
      </div>
      <div className="activity-card__content">
        <h3 className="activity-card__title" style={titleClampStyle}>{activity.title}</h3>
        <span className="activity-card__link">
          <Image
            src={getImageUrl(activity.icon)}
            alt="Arrow icon"
            width={40}
            height={40}
          />
        </span>
      </div>
    </Link>
  );
}
